"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
// loads data from the backend API into the transport-air store
function fetchAir(_a) {
    var getters = _a.getters, dispatch = _a.dispatch;
    return __awaiter(this, void 0, void 0, function () {
        var generalCruise, _b, adults, juveniles, children, id, priceModel, arrivalGermany, departureGermany, mandatoryFlight, params, cabinCode, cheapestCode;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    generalCruise = getters['generalCruise'];
                    if (!generalCruise && isEmpty(generalCruise)) {
                        return [2 /*return*/];
                    }
                    _b = getters['persons/all'], adults = _b.adults, juveniles = _b.juveniles, children = _b.children;
                    id = generalCruise.id, priceModel = generalCruise.priceModel, arrivalGermany = generalCruise.arrivalGermany, departureGermany = generalCruise.departureGermany, mandatoryFlight = generalCruise.mandatoryFlight;
                    params = {
                        arrivalGermany: arrivalGermany,
                        cabinCategory: undefined,
                        cruiseId: id,
                        departureGermany: departureGermany,
                        flightOpts: {
                            adults: adults,
                            juveniles: juveniles,
                            children: children,
                            priceModel: priceModel,
                        },
                        preselect: false,
                        preselectLowestPrice: undefined,
                        roundtripsOnly: undefined,
                        withNoFlight: undefined,
                        withOutNoFlight: undefined,
                        withRetNoFlight: undefined
                    };
                    // if priceModel == JUST, preselect a flight immediately <- DONT!!
                    if (priceModel && priceModel.toUpperCase() === 'JUST') {
                        params.preselect = true;
                        cabinCode = getters['cabins/selectedCabinCategoryCode'];
                        if (cabinCode) {
                            params.cabinCategory = cabinCode;
                        }
                        else {
                            cheapestCode = getters['cabins/cheapestCabinCategoryCode'];
                            params.cabinCategory = cheapestCode;
                        }
                    }
                    if (mandatoryFlight && mandatoryFlight[params.flightOpts.priceModel] &&
                        !getters['transportAir/selectedConnection']) {
                        params.preselectLowestPrice = true;
                        if (departureGermany && arrivalGermany) {
                            params.preselectLowestPrice = false;
                        }
                    }
                    if (mandatoryFlight && mandatoryFlight[params.flightOpts.priceModel] && !departureGermany && !arrivalGermany) {
                        // params.withNoFlight = false
                        params.withOutNoFlight = false;
                        params.withRetNoFlight = false;
                        params.roundtripsOnly = true;
                    }
                    else if (mandatoryFlight && mandatoryFlight[params.flightOpts.priceModel] && !departureGermany && arrivalGermany) {
                        // params.withNoFlight = false
                        params.withOutNoFlight = false;
                        params.withRetNoFlight = true;
                        params.roundtripsOnly = false;
                    }
                    else if (mandatoryFlight && mandatoryFlight[params.flightOpts.priceModel] && departureGermany && !arrivalGermany) {
                        // params.withNoFlight = false
                        params.withOutNoFlight = true;
                        params.withRetNoFlight = false;
                        params.roundtripsOnly = false;
                    }
                    else {
                        // params.withNoFlight = true
                        params.withOutNoFlight = true;
                        params.withRetNoFlight = true;
                        params.roundtripsOnly = false;
                    }
                    // if priceModel == PAUSCHAL and cruise does not start and not end in Germany,
                    // preselect a flight immediately
                    if (priceModel.toUpperCase() === 'PAUSCHAL' &&
                        !getters['transportAir/selectedConnection']) {
                        params.preselectLowestPrice = true;
                        if (departureGermany && arrivalGermany) {
                            params.preselectLowestPrice = false;
                        }
                    }
                    if (priceModel === 'PAUSCHAL' && !departureGermany && !arrivalGermany) {
                        // params.withNoFlight = false
                        params.withOutNoFlight = false;
                        params.withRetNoFlight = false;
                        params.roundtripsOnly = true;
                    }
                    else if (priceModel === 'PAUSCHAL' && !departureGermany && arrivalGermany) {
                        // params.withNoFlight = false
                        params.withOutNoFlight = false;
                        params.withRetNoFlight = true;
                        params.roundtripsOnly = false;
                    }
                    else if (priceModel === 'PAUSCHAL' && departureGermany && !arrivalGermany) {
                        // params.withNoFlight = false
                        params.withOutNoFlight = true;
                        params.withRetNoFlight = false;
                        params.roundtripsOnly = false;
                    }
                    // populate store from the backend API
                    return [4 /*yield*/, dispatch('transportAir/fetch', params)];
                case 1:
                    // populate store from the backend API
                    _c.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.default = fetchAir;
function isEmpty(obj) {
    for (var prop in obj) {
        if (obj.hasOwnProperty(prop))
            return false;
    }
    return JSON.stringify(obj) === JSON.stringify({});
}
//# sourceMappingURL=fetch_air.js.map